export function useMatchMedia(
  mediaQuery: MaybeRefOrGetter<string>,
  listener: (event: MediaQueryListEvent) => any
) {
  onMounted(() => {
    const media = window!.matchMedia(toValue(mediaQuery))
    media.addEventListener('change', listener)

    onUnmounted(() => {
      media.removeEventListener('change', listener)
    })
  })
}